'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var titan = require('@narvar/titan-client');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var titan__default = /*#__PURE__*/_interopDefaultLegacy(titan);

const TitanAnalyticsContext = /*#__PURE__*/React.createContext(undefined);
const TitanAnalyticsProvider = TitanAnalyticsContext.Provider;
const useTitanAnalytics = () => {
  const context = React.useContext(TitanAnalyticsContext);
  const {
    sourceWriteKey,
    dataPlaneUrl
  } = context ?? {};
  const titanAnalytics = React.useMemo(() => {
    if (!sourceWriteKey || !dataPlaneUrl) {
      return undefined;
    }

    // titan relies on browser crypto API
    if (typeof window !== 'undefined') {
      return titan__default["default"]({
        sourceWriteKey,
        url: dataPlaneUrl
      });
    }
    return undefined;
  }, [sourceWriteKey, dataPlaneUrl]);
  return titanAnalytics;
};

exports.TitanAnalyticsContext = TitanAnalyticsContext;
exports.TitanAnalyticsProvider = TitanAnalyticsProvider;
exports["default"] = useTitanAnalytics;
